<template>
  <c-modal
    v-model="modal"
    cancel-label="Close"
    centered
    no-close-on-esc
    no-close-on-backdrop
    title="Please crop image"
    :tag="false"
    confirm-label="Submit Photo"
    :progressing="progressing"
    size="lg"
    @show="show"
    @submit="sendCropedImage"
  >
    <template>
      <div class="crop-wrapper-scrollable">
        <p v-if="src.search('image/gif') !== -1" class="text-center text-danger" style="font-size: 1.2rem; font-weight: bold;">Cropping is not available for GIFs</p>
        <img class="image-container" ref="image" :src="src"/>
      </div>
      <input class="mt-3" type="checkbox" v-model="Vertical" /><label> Vertical Image</label>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "./Cmodal";
  import Cropper from "cropperjs";

  export default {
    name: "ImageCropper",
    components: {CModal},
    props: {
      value: {
        required: true,
        type: Boolean,
        default: false
      },
      src: {
        required: true
      },
      ratio: {
        required: false,
        default: 1/1
      },
      verticalRatio: {
        required: false,
        default: 12 / 16
      }
    },
    data () {
      return {
        progressing: false,
        image: {},
        cropper: {},
        destination: {},
        Vertical: false
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    updated(){
      this.cropper.destroy()
      this.show()
    },
    beforeDestroy(){
      this.cropper.destroy()
    },
    methods: {
      show () {
        let ratio = this.ratio
        if(this.Vertical){
          ratio = this.verticalRatio
        }else{
          ratio = this.ratio
        }
        this.$nextTick(() => {
          this.image = this.$refs.image
          this.cropper =  new Cropper(this.image, {
            scalable: false,
            zoomable: true,
            aspectRatio: ratio,
            viewMode: 2,
            autoCropArea:1,
            ready: () => {
              // var style = window.getComputedStyle(document.querySelector('.cropper-crop-box'));
              // var matrix = new WebKitCSSMatrix(style.webkitTransform);
              // var cropperOHeight = matrix.f
            },
            crop: () => {
              const canvas = this.cropper.getCroppedCanvas();
              if(this.src.search("image/gif") != -1){
                // For GIFs, we need to preserve the original GIF data
                const base64Data = this.src.split(',')[1];
                this.destination = `data:image/gif;base64,${base64Data}`;
                
              }else{
                this.destination = canvas.toDataURL('image/png')                
              }
            }
          })
        })
      },
      sendCropedImage () {
        this.$emit('completeCrop', this.destination, this.Vertical)
      }
    }
  }
</script>
<style>
  .crop-wrapper-scrollable{
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }

  .crop-wrapper-scrollable .image-container{
    display: block;
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 575.98px){
    .crop-wrapper-scrollable{
      max-height: 45vh;
    }
  }

  @media (min-width: 992px){
    .crop-wrapper-scrollable{
      max-height: 70vh;
    }
  }
</style>

